import apiUsers from '@/api/users'

const state = {
  error: null,
  isSubmitting: false
}

export const mutationTypes = {
  createUserStart: '[create user] Create user start',
  createUserSuccess: '[create user] Create user success',
  createUserFailure: '[create user] Create user failure'
}

export const actionTypes = {
  createUser: '[create user] Create user'
}

const mutations = {
  [mutationTypes.createUserStart](state) {
    state.isSubmitting = true
    state.error = null
  },

  [mutationTypes.createUserSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.createUserFailure](state, payload) {
    state.error = payload
    state.isSubmitting = false
  }
}

const actions = {
  [actionTypes.createUser](context, {user}) {
    context.commit(mutationTypes.createUserStart)
    return new Promise(resolve => {
      apiUsers
        .createUser(user)
        .then(response => {
          context.commit(mutationTypes.createUserSuccess)
          resolve(response.data)
        })
        .catch(resolve => {
          context.commit(
            mutationTypes.createUserFailure,
            resolve.response.data.errors
          )
        })
    })
  }
}

export default {
  state,
  mutations,
  actions
}
